import React, { Component } from 'react'
import errorIcon from '../../assets/images/newui/information.svg'

export class GeneralError extends Component {
    render() {
        return (
            <div ref={this.props.innerRef} className={`general-msg ${this.props.type ? this.props.type : 'error'}`}>
                <i className="error-icon"></i>
                <div>{this.props.message}</div>

            </div>
        )
    }
}

export default React.forwardRef((props, ref) => <GeneralError
    innerRef={ref} {...props}
/>);
